<template>
  <v-tooltip bottom max-width=300>
    <template v-slot:activator="{ on }">
      <v-icon
        v-on="on"
        tabindex="0"
        role="button"
        :aria-label="helpLabel"
      >help_outline</v-icon>
    </template>
    <span><slot/></span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    helpLabel: {
      type: String,
      default: 'Help'
    }
  }
}
</script>